import { Result, Spin, message } from "antd"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useHistory, useParams } from "react-router-dom"
import styled from "styled-components"

import { createBooking } from "../../../../../api"

// ----------------------------------------------------------------------------

function _BookingRedirect(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const { id: ghostId } = useParams()
    const history = useHistory()
    const [error, setError] = useState(false)

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        createBooking(null, { ghostId })
            .then((booking) => {
                history.push("/booking")
            })
            .catch((e) => {
                setError(e.message)
                message.error(e.message)
            })
        //eslint-disable-next-line
    }, [])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            {error ? (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: 500,
                    }}
                >
                    <Result
                        status={"error"}
                        title={"Errore"}
                        subTitle={error}
                    />
                </div>
            ) : (
                <Spin spinning>
                    <div style={{ height: 500 }}></div>
                </Spin>
            )}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_BookingRedirect.propTypes = {
    className: PropTypes.string.isRequired,
}

_BookingRedirect.defaultProps = {}

// ----------------------------------------------------------------------------

const BookingRedirect = styled(_BookingRedirect)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default BookingRedirect
